export default "__VITE_ASSET__5832c406__"